import { domToPng } from "modern-screenshot";

// Render a DOM node (the membership card) to a PNG and trigger a download.
// Uses modern-screenshot, which reliably embeds images/fonts without the
// hangs html-to-image hit on this card.
export async function downloadCardImage(node, filename = "membership-card.png") {
  if (!node) return;
  const dataUrl = await domToPng(node, {
    scale: 3,
    // Transparent outside the card's rounded corners.
    backgroundColor: "transparent",
  });
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export const cardFileName = (membershipNumber, name) => {
  const safe = (name || "card").replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  return `magicdil-${membershipNumber || "card"}-${safe}.png`;
};
